import { createContext, useContext, useState, ReactNode } from 'react';

interface SelectedRelayContextType {
  selectedRelayId: string | null;
  setSelectedRelayId: (id: string | null) => void;
  clearSelectedRelay: () => void;
}

const SelectedRelayContext = createContext<SelectedRelayContextType | undefined>(undefined);

export const SelectedRelayProvider = ({ children }: { children: ReactNode }) => {
  const [selectedRelayId, setSelectedRelayIdState] = useState<string | null>(() => {
    // Récupérer le point relais depuis le sessionStorage (pas localStorage pour que ça ne persiste pas entre sessions)
    const saved = sessionStorage.getItem('selectedRelayId');
    return saved || null;
  });

  const setSelectedRelayId = (id: string | null) => {
    setSelectedRelayIdState(id);
    if (id) {
      sessionStorage.setItem('selectedRelayId', id);
    } else {
      sessionStorage.removeItem('selectedRelayId');
    }
  };

  const clearSelectedRelay = () => {
    setSelectedRelayIdState(null);
    sessionStorage.removeItem('selectedRelayId');
  };

  return (
    <SelectedRelayContext.Provider value={{ selectedRelayId, setSelectedRelayId, clearSelectedRelay }}>
      {children}
    </SelectedRelayContext.Provider>
  );
};

export const useSelectedRelay = () => {
  const context = useContext(SelectedRelayContext);
  if (!context) {
    throw new Error('useSelectedRelay must be used within a SelectedRelayProvider');
  }
  return context;
};
